import React, { useEffect, useState } from "react";
import api from "@/lib/api";

/* ============================================================================
   CoeAuditTab — chronological view of every COE management action.
   Powered by the existing audit_log collection (filtered to entity_type='coe_member').
   ========================================================================== */

const ACTION_LABELS = {
    coe_person_created: "Member added",
    coe_person_updated: "Member updated",
    coe_person_toggled: "Toggle active",
    coe_role_created:   "Role created",
    coe_role_updated:   "Role updated",
    coe_role_deleted:   "Role deleted",
    coe_invite_created: "Invite created",
    coe_invite_revoked: "Invite revoked",
    coe_invite_accepted: "Invite accepted",
};

const fmtDT = (s) => new Date(s).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

export function CoeAuditTab() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/admin/coe/audit", { params: { limit: 200 } })
            .then((r) => setRows(r.data || []))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="rounded-2xl border border-border bg-card p-5" data-testid="coe-audit-tab">
            <div className="text-[10px] font-bold tracking-[0.18em] uppercase text-muted-foreground mb-3">
                COE audit trail ({rows.length})
            </div>
            {loading ? (
                <div className="text-muted-foreground text-sm text-center py-8">Loading…</div>
            ) : rows.length === 0 ? (
                <div className="text-muted-foreground text-sm text-center py-8" data-testid="coe-audit-empty">
                    No audit events yet. Every create / edit / role-change will appear here.
                </div>
            ) : (
                <ul className="space-y-3 max-h-[700px] overflow-y-auto pr-1">
                    {rows.map((e) => (
                        <li key={e.id} className="flex gap-3 pb-3 border-b border-border last:border-0" data-testid={`coe-audit-row-${e.id}`}>
                            <div className="w-8 h-8 rounded-full bg-secondary grid place-items-center text-[10px] font-bold text-muted-foreground shrink-0">
                                {(e.actor_name || "?").slice(0, 1).toUpperCase()}
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="flex items-baseline justify-between gap-2 flex-wrap">
                                    <div className="text-sm">
                                        <span className="font-semibold">{e.actor_name || "System"}</span>{" "}
                                        <span className="text-muted-foreground">·</span>{" "}
                                        <span className="text-[10px] uppercase tracking-wide font-bold text-muted-foreground">
                                            {ACTION_LABELS[e.action] || e.action.replace(/_/g, " ")}
                                        </span>
                                    </div>
                                    <div className="text-[10px] text-muted-foreground tabular-nums">{fmtDT(e.created_at)}</div>
                                </div>
                                {e.summary && <div className="text-xs text-muted-foreground mt-0.5">{e.summary}</div>}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
